module.exports = __webpack_public_path__ + "static/media/banner.589b6071.jpeg";